export default __webpack_public_path__ + "static/media/elephant.20967cff.svg";